<template>
  <Page :title="title">

            <div class="van-collapse-item__content"  style="padding-bottom:1rem;" ref="cc">
              <div class="van-collapse-item__content-flex">
                            <!-- 课程名称 -->
                    <div class="flex itemCenter cell-list-item">
                        <div class="input-title">{{titlename}}：</div>
                        <input
                            type="text"
                            class="inputs"
                            v-model="courseMember['name']"
                            placeholder="请输入课程名称"
                            maxlength="100"
                            disabled="true"
                        >
                    </div>
             </div>
              <div class="swaper">
                <van-swipe :autoplay="3000" style="width: 100%;height: 100%;">
                  <van-swipe-item
                    v-for="(image, index) in images"
                    :key="index"
                    @click="ImagePreview(index)"
                  >
                    <img   :src="image" style="width: 100%;height: 100%;">
                  </van-swipe-item>
                </van-swipe>
              </div>

              <div class="give-mark">
                 
                <van-rate
                v-model="reviewScore"
                :size="23"
                :count="5"
                color="#F5A623"
                void-color="#F4D39C"
                :disabled="lookProduction"
                :disabled-color="'#F5A623'"
              />

              <textarea name="" id=""   disabled="true"   v-model="courseMember['review']"  v-if="lookProduction&&courseMember['review']!=''" cols="30" rows="10"  class="textarea"></textarea>

              </div>
              
              <div class="give-mark" v-if="lookProduction==false">
                <!--  v-if="lookProduction==false" -->
                <textarea name="" id=""    placeholder="请输入点评"  v-model="reviewrd"   cols="30" rows="10"  class="textarea"></textarea>
              </div>



                    <div class="flex itemCenter cell-list-item"  v-if="lookProduction">
                        <div class="input-title">点评人：</div>
                        <input
                            type="text"
                            class="inputs"
                            v-model="courseMember['userName']"
                            placeholder=""
                            maxlength="100"
                            :disabled="lookProduction"
                        >
                    </div>
                     <div class="flex itemCenter cell-list-item"  v-if="lookProduction">
                        <div class="input-title">点评时间：</div>
                        <input
                            type="text"
                            class="inputs"
                            v-model="courseMember['reviewTime']"
                            placeholder=""
                            maxlength="100"
                            :disabled="lookProduction"
                        >
                    </div>                   

           </div>
           <div class="bottom-button" >
                 <div class="submit"  v-if="hasFunAuth&&lookProduction==false" @click="submit">提交</div>
                 <div class="back"   v-if="lookProduction" @click="back">返回</div>
           </div>
  </Page>
</template>




<script>
import $api from "../../api/lkcollege_api"; // 接口
import { Dialog, Toast, Notify, ImagePreview } from "vant";
export default {
  data() {
    return {
      titlename:"课程名称",
      count: 5, //星星总数
      value: 3, //星星选择数
      title: "查看作品",
      commentsonPeople: "李书记",
      createdate: "2018-08-08 12:40:12",
      images: [
      ],
      lookProduction:false,   // true  只能查看  false 可以点评
      courseMember:{
        name:"",              // 课程名称
        reviewScore:"",       // 评分
        review:"",            // 评价
        userName:"",          // 评价人
        reviewTime:"",        // 评点时间

      },        // 课程内容 储存
      imgList:[{
        U_StaticResorurceId:"",			
        U_url:"https://img.yzcdn.cn/public_files/2017/09/05/fd08f07665ed67d50e11b32a21ce0682.jpg",	
        U_Sort:"",
      }],             // 轮播图
    reviewrd:'',
    G:'',            //  1 参与活动进入   参与课程进入
    menuId:"",      //   菜单ID
    hasFunAuth:false,
    reviewScore:0   ,  //评分
    };
  },
  methods: {
    //返回
    back() {
      this.$router.back(1);
    },
    submit(){
       if(this.reviewrd==''){
         this.$title("请输入点评")
         return;
       }
      if(this.reviewScore==''||this.reviewScore==0){
         this.$title("请评分")
         return;
       }
       if(this.G==2){
         let data ={
          salesId:this.$wxuserUtil.getUserId(),
          courseMemberId:this.courseMemberId,
          review:this.reviewrd,
          reviewScore:this.reviewScore,           
         }
         this.$loading();
        this.$api.saveWorksReviewCourse(data).then(Response=>{
            if(Response.success){
               this.$clear("提交成功"); 
                    setTimeout(() => {
                             this.$router.back(1);
                    }, 500);
            }else{
                 this.$title(Response.msg)
            }
        })
       }else{
         let data  ={
          salesId:this.$wxuserUtil.getUserId(),
          "pojo.id":this.courseMemberId,
          "pojo.review":this.reviewrd,
          "pojo.reviewScore":this.reviewScore,           
         }
         this.$loading();
        this.$api.saveWorksReviewCampaigns(data).then(Response=>{
            console.log("参与活动 作品提交返回",Response)
            
            if(Response.success){
              this.$clear("提交成功"); 
                    setTimeout(() => {
                             this.$router.back(1);
                    }, 500);
            }else{
                 this.$title(Response.msg)
            }
        })
       }


    },
    //切换图片
    ImagePreview(index) {
    ImagePreview({
      images:this.images,
      startPosition: index,
      onClose() {
        // do something
      }
});
    },
    // 课程作品详情
    getCourseDetailWorks(ID,salesId){
      this.$api.getCourseDetailWorks({
        salesId: salesId,
        courseMemberId:ID
      }).then(Response=>{
              console.log("作品详情来自课程",Response)
              let img=[]
              if(Response.success){                  
                   this.courseMember['name']=Response.data.courseMember.name||''
                   this.reviewScore=Response.data.courseMember.reviewScore?Response.data.courseMember.reviewScore:0
                   this.courseMember['review']=Response.data.courseMember.review||''
                   this.courseMember['userName']=Response.data.courseMember.userName||''
                   this.courseMember['reviewTime']=Response.data.courseMember.reviewTime||''         
                   this.imgList=Response.data.imgList
                   if(this.imgList.length>0){
                     for(let i=0;i<this.imgList.length;i++){
                        img.push( this.$http+'upload/'+this.imgList[i]['U_url'])
                    }

                   this.images=img;
                   console.log("图片列表",this.images)
                   }
              }else{
                 this.$title(Response.msg)
              }
      })
    },
  // 活动作品查看详情
  getCampaignDetailWorks(ID,salesId){
       this.$api.getCampaignDetailWorks({
        salesId: salesId,
        campMemberId:ID
      }).then(Response=>{
              console.log("作品详情来自活动",Response)
              let img=[]
              if(Response.success){
                   this.courseMember['name']=Response.data.campMember.campName||''
                   this.reviewScore=Response.data.campMember.U_ReviewScore?Response.data.campMember.U_ReviewScore:0
                   this.courseMember['review']=Response.data.campMember.U_Review||''
                   this.courseMember['userName']=Response.data.campMember.reviewUserName||''
                   this.courseMember['reviewTime']=Response.data.campMember.reviewTime||''
                   this.imgList=Response.data.imgList
                   if(this.imgList.length>0){
                     for(let i=0;i<this.imgList.length;i++){
                        img.push( this.$http+'upload/'+this.imgList[i]['U_url'])
                    }

                   this.images=img;
                   console.log("图片列表",this.images)
                   }
              }else{
                 this.$title(Response.msg)
              }
      })    
  },
  // 活动作品提交接口
  saveWorksReviewCampaigns(){},


  },
  mounted() {
    let { lookProduction, ID,G,menuId} = this.$route.query;
    console.log("是否有评论人ID",lookProduction)
    this.courseMemberId=ID;
    this.menuId=menuId;
    this.lookProduction=lookProduction=="true"||lookProduction==true?true:false;
    console.log("渲染后得",this.lookProduction)
    this.G=G;
    if (ID&&G==1) {
      this.getCampaignDetailWorks(ID, this.$wxuserUtil.getUserId());
      this.titlename="活动名称";
    }
    if (ID&&G==2) {
      this.getCourseDetailWorks(ID, this.$wxuserUtil.getUserId());   
      this.titlename="课程名称";         
    }
    if(this.$wxuserUtil.hasFunAuthByRouteInst(this.$route,this.$funcKey.ReviewCreated,true,'无点评权限')){
               this.hasFunAuth=true            
     }else{     
               this.hasFunAuth=false;
     }
      if(this.$phones==1){
     this.$refs.cc.style.height=localStorage.getItem('heights')-40+'px';
     }else{
     this.$refs.cc.style.height=localStorage.getItem('heights')-40+'px';
     }       
  },
  watch: {},
  created() {
  },
  components: {}
};
</script>
<style lang="less" scoped  src="~p/pageView-filter.less"></style>  
<style lang="less"  scoped>
.bottom-button{
  position: fixed;
  bottom: 0;
  height: 40px;
  width:100%;
  .submit{
    width:100%;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background: #E2050E;
    color:#fff;
  }
  .back{
    width:100%;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background: #E2050E;
    color:#fff;
  }
}
.van-collapse-item__content-flex{
  overflow: hidden;
}
.van-collapse-item__content{
  padding: 0px;
  overflow-y: auto;
  height: 100%;
  .textarea{
    border:none;
    width: 100%;
    height: 1.5rem;
    margin-top: .3rem;
    margin-bottom: .3rem;
    background: #fff;
  }
  .cell-list-item{
    padding: 0px;
    margin: 0.3rem  .3rem;
    .input-title{
      padding-left: .3rem;
    }
  }
  .give-mark{
    margin: 1.5rem .3rem;
    border: 1px solid #ccc;
    padding: .15rem;
    -ms-flex-item-align: center;
    align-items: center;
    display: flex;
    flex-direction: column;

  }
}
.swaper{
  height: 5rem;
  padding: 0 .3rem;
  margin-top:.5rem;
}

</style>



// WEBPACK FOOTER //
// src/components/lkcollege/lookProduction.vue